import { differenceInSeconds, isValid } from 'date-fns';

export const getSecondsLeft = (expiryDate: Date | number) => {
  const parsedDate = new Date(expiryDate);

  if (!isValid(parsedDate)) {
    return 0;
  }

  return Math.max(0, differenceInSeconds(parsedDate, new Date()));
};
